var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-provider"},[_vm._t("default",null,{"cubeApi":_vm.cubeApi})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }